import { createContext, useEffect, useState } from "react";
import { getAuditTrailByid } from '../../redux/auditTrailSlice'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

export const AuditTrailViewContext = createContext({});

export const AuditTrailViewContextProvider = ({children}) =>{

      const dispatch = useDispatch()
      const {audit_trail_id} = useParams()
      const [viewData,setViewData] = useState({action:""}) 
      useEffect(()=>{
        (async()=>{
            const resp = await  dispatch(getAuditTrailByid({id:audit_trail_id}))
            setViewData(resp.payload.results)
        })()
      },[dispatch,audit_trail_id])

    return <AuditTrailViewContext.Provider value={{data:viewData}}>{children}</AuditTrailViewContext.Provider>
}

